// helpers.ts -- Pure utility functions for J201 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Approval status badge
 *  統一狀態碼（規格法定值）：N=草稿/已沖銷、D=送審中、P=已核准
 *  （自創碼 S/R/V 已廢除；S 保留映射僅供顯示殘留舊值） */
export const getApprovalBadge = (status: string | undefined): { text: string; cls: string } => {
  switch (status) {
    case 'P': return { text: '已核准', cls: 'badge-success' };
    case 'D': return { text: '送審中', cls: 'badge-warning' };
    case 'S': return { text: '送審中(舊碼)', cls: 'badge-warning' };
    default: return { text: '草稿', cls: 'badge-default' };
  }
};

/** Invoice type options */
export const INVOICE_TYPE_OPTIONS = [
  { value: 1, label: '三聯式' },
  { value: 2, label: '二聯式' },
  { value: 3, label: '外銷發票-零稅率' },
  { value: 4, label: 'DN-內' },
  { value: 5, label: 'DN-外' },
];
